import { Injectable, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, tap, map } from 'rxjs';
import { MenuItem } from '../models/menu-item.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private http = inject(HttpClient);
  private readonly apiUrl = `/assets/data/navigation.json`;

  private _menuItems = signal<MenuItem[]>([]);
  readonly menuItems = this._menuItems.asReadonly();

  /**
   * Loads the sidebar nav tree. Source is a static JSON asset for now;
   * swapping this to a per-subscription backend endpoint later only
   * requires changing this method, not any consumer.
   */
  loadMenu(): Promise<void> {
    // Cache-bust: unlike the hashed JS bundle, this static JSON asset has no
    // content hash in its filename, so an intermediary cache (CDN/browser)
    // can keep serving a stale copy across deploys. Force a fresh fetch.
    const url = `${this.apiUrl}?v=${Date.now()}`;
    return lastValueFrom(
      this.http.get<MenuItem[]>(url).pipe(
        tap(items => this._menuItems.set(items)),
        map(() => void 0)
      )
    ).catch(err => {
      if (environment.environmentName !== 'DEV') {
        console.error('Failed to load navigation from JSON:', err);
        throw err;
      }
      console.warn('Failed to load navigation from JSON, using local fallback.', err);
      this._menuItems.set([
        { label: 'Dashboard', icon: 'pi pi-th-large', path: '/dashboard' }
      ]);
    });
  }
}
